<div class="d-flex flex-column align-items-center my-5">
  <h1>Accès non autorisé</h1>
  <p *ngIf="!codeChantier">Vous n’avez le droit d’accéder au suivi des heures d’insertion sur aucun chantier. Contactez votre administrateur.</p>
  <p *ngIf="codeChantier">Vous n’avez pas le droit d’accéder au suivi des heures d’insertion pour le chantier {{codeChantier}}. Contactez votre administrateur.</p>
  <button *ngIf="codeChantier" class="btn btn-primary" routerLink="/">Retourner à l'accueil</button>
</div>

